export const getHoursSuffix = (hours) => {
    if (hours > 10 && hours < 20) {
        return "ов";
    }

    const digit = hours % 10;
    if (digit === 1) {
        return "";
    }
    if (digit >= 2 && digit <= 4) {
        return "а";
    }
    if (digit === 0 || (digit > 4 && digit <= 9)) {
        return "ов";
    }
    return "";
};

export const getMinutesSuffix = (minutes) => {
    if (minutes >= 10 && minutes < 20) {
        return "";
    }

    const digit = minutes % 10;

    if (digit === 1) {
        return "а";
    }
    if (digit >= 2 && digit <= 4) {
        return "ы";
    }
    if (digit === 0 || (digit > 4 && digit <= 9)) {
        return "";
    }

    return "";
};

export const isLuxonDayEquals = (date1, date2) =>
    date1.startOf("day").toMillis() === date2.startOf("day").toMillis();
